import { render, staticRenderFns } from "./CaseToolbar.vue?vue&type=template&id=35490b02&lang=pug&"
import script from "./CaseToolbar.vue?vue&type=script&lang=js&"
export * from "./CaseToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports